import ReactMarkdown from 'react-markdown'
import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'

interface TenderSummaryCardProps {
  summary: string
  /** When set, renders a "View full summary" link to the detailed Tender Summary. */
  fullSummaryTo?: string | undefined
}

export function TenderSummaryCard({ summary, fullSummaryTo }: TenderSummaryCardProps) {
  return (
    <section>
      <div className="mb-3 flex items-center gap-1.5">
        <h2 className="text-sm font-medium">AI Summary</h2>
      </div>
      <div className="rounded-xl border bg-card shadow-sm p-4">
        <div className="prose prose-sm max-w-none text-foreground">
          <ReactMarkdown>{summary.replace(/^#\s+.+\n*/m, '')}</ReactMarkdown>
        </div>
        {fullSummaryTo && (
          <Link
            to={fullSummaryTo}
            className="mt-2 inline-flex items-center gap-0.5 text-xs text-[hsl(var(--link))] hover:underline"
          >
            View full summary
            <ChevronRight className="h-3.5 w-3.5 shrink-0" aria-hidden />
          </Link>
        )}
      </div>
    </section>
  )
}
